import { useEffect, useMemo, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import api from "../api/api";
import { CircularProgress, Box, Backdrop } from "@mui/material";
import SideNavLayout from "../Sidenav/SideNavLayout";
import { useSelector } from "react-redux";
import ReportsFilters from "./Reportsfilter";
import ReportsData from "./ReportsData";
import DateRangeSelector from "../daterangepicker/DateRangeSelector";
import Calendar1 from '../../src/assets/Calender.svg';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import weekday from "dayjs/plugin/weekday";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useLocation } from "react-router-dom";
import HistoryPage from "./historypage";
import { format } from 'date-fns';

dayjs.extend(weekday);
dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);
 
const getWeekDays = (start) => {
  const days = [];
  for (let i = 0; i < 7; i++) {
    days.push(dayjs(start).add(i, 'day').format("dddd")); // "Monday", "Tuesday", etc.
  }
  return days;
};
 
 
const ReportHome = () => {
  const [loadingTable, setLoadingTable] = useState(false);
  const [tableData, setTableData] = useState({});
  const [backupData, setBackupData] = useState([]);
  const historycalendarref=useRef('')
    const user = useSelector((state) => state.user.userDetails);
  const currentFilter = [
    { label: 'EMP', count: '0', value: "EMP" },
    { label: 'EQP', count: '0', value: "EQP" },
  ];
    const [token, setToken] = useState(null);
const [historycalendar, sethistoryCalendar] = useState([
  {
    startDate: dayjs().subtract(7, "day").toDate(), // 7 days ago
    endDate: dayjs().toDate(),  
    key: "selection",
  },
]);

  const [historycalendermodal,setHistoryCalenderModal]=useState(false)
    const [historysearch,setHistorySearch]=useState('')
    const [ui,setui]=useState(0)
  const [searchQuery, setSearchQuery] = useState('');
  const [activeFilter, setActiveFilter] = useState('NOFILTER');
  const [companyTabs, setCompanyTabs] = useState([]);
const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [openCalendar, setOpenCalendar] = useState(false);
  const calendarRef = useRef(null);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSuggestions, setSelectedSuggestions] = useState([]);
  const [selectedJobDetails, setSelectedJobDetails] = useState([]);
  const dropdownRef = useRef(null);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const location = useLocation();
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });
  const [historyData,setHistoryData]=useState([])
 const[isloading,setIsLoading]=useState(false)
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [tempSelectedFilters, setTempSelectedFilters] = useState(['EMP', 'EQP']);
  const [selectedCompanyName, setSelectedCompanyName] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [reportTableData, setReportTableData] = useState([]);
  const [hoveredSuggestionIndex, setHoveredSuggestionIndex] = useState(-1);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get('allow');
 
    if (accessToken) {
      setToken(accessToken);
   
    }
  }, [location.search]);

  const handleKeyDown = (e) => {
    if (e.key === 'Tab' && hoveredSuggestionIndex >= 0 && suggestions[hoveredSuggestionIndex]) {
      e.preventDefault(); // Prevent default Tab behavior (e.g., focus shift)
      handleSuggestionClick(suggestions[hoveredSuggestionIndex]);
    } else if (e.key === 'ArrowDown') {
      // Optional: Navigate suggestions with arrow keys
      e.preventDefault();
      setHoveredSuggestionIndex((prev) =>
        prev < suggestions.length - 1 ? prev + 1 : prev
      );
    } else if (e.key === 'ArrowUp') {
      // Optional: Navigate suggestions with arrow keys
      e.preventDefault();
      setHoveredSuggestionIndex((prev) => (prev > 0 ? prev - 1 : prev));
    }
  };


const fecthhistorydata = async (dateRange) => {
  try {
    setIsLoading(true);


    // Use provided range or fallback to today's date
    const range = dateRange?.[0] || {
      startDate: dayjs().subtract(7, "day").toDate(),
      endDate: dayjs().toDate(),
    };

    const startDate = format(range.startDate, "yyyy-MM-dd");
    const endDate = format(range.endDate, "yyyy-MM-dd");
    let url = `/v1/reports/all?start_date=${startDate}&end_date=${endDate}`;
if(user?.user_roles?.role === 'Supervisor'){
 url += `&user_id=${user?.id}`;
}
const response = await api.get(url);

    if (response.status === 200) {
      setHistoryData(response?.data || []);
    } else {
      setHistoryData([]);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};

useEffect(()=>{
  if(ui==1&&user){
    fecthhistorydata(historycalendar)
  }
},[ui,historycalendar,user])
  const handleCheckboxChange = (value) => {
    let updatedFilters = [...tempSelectedFilters];
    if (updatedFilters.includes(value)) {
      updatedFilters = updatedFilters.filter(item => item !== value);
    } else {
      updatedFilters.push(value);
    }
 
    if (updatedFilters.length === 0) {
      updatedFilters = ['EMP', 'EQP'];
    }
 
    setTempSelectedFilters(updatedFilters);
  };
 
  const handleApplyFilters = () => {
    setTempSelectedFilters(tempSelectedFilters);
 
    if (tempSelectedFilters.length === 2) {
      setActiveFilter('NOFILTER');
    } else if (tempSelectedFilters.length === 1) {
      setActiveFilter(tempSelectedFilters[0]);
    }
 
    setIsFilterOpen(false);
  };
 
  const handleDateRangeSubmit = () => {
    setOpenCalendar(false);
  };
  const generateCSV = () => {
  const empReport = memoizedFullData?.emp_report;
  if (!empReport || Object.keys(empReport).length === 0) return;

  const weekEndingDate = dayjs(selectedDateRange.endDate).format("MM/DD/YYYY");

  const headers = ["Week Ending Date", "Job Number", "Cost Code", "Employee/Equipment", "Cost Unit", "Total Hours"];
  const rows = [headers];

  Object.values(empReport).forEach((employee) => {
    const name = employee.emp_name || "";

    // Aggregate hours per job number across all activity/work_details
    const jobHoursMap = {};

    (employee.activity || []).forEach((act) => {
      (act.work_details || []).forEach((wd) => {
        const jobId = wd.job_id || "";
        const [hh, mm] = (wd.hours || "0:00").split(":").map(Number);
        const decimal = hh + mm / 60;
        jobHoursMap[jobId] = (jobHoursMap[jobId] || 0) + decimal;
      });
    });

    if (Object.keys(jobHoursMap).length === 0) {
      // No work details — still output a row with total_hours
      const [hh, mm] = (employee.total_hours || "0:00").split(":").map(Number);
      const totalDecimal = (hh + mm / 60).toFixed(2);
      rows.push([weekEndingDate, "", "2600", name, "0", totalDecimal]);
    } else {
      Object.entries(jobHoursMap).forEach(([jobId, hours]) => {
        rows.push([weekEndingDate, jobId, "2600", name, "0", hours.toFixed(2)]);
      });
    }
  });

  const csvContent = rows
    .map((row) => row.map((val) => `"${String(val).replace(/"/g, '""')}"`).join(","))
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `report_week_ending_${dayjs(selectedDateRange.endDate).format("YYYY-MM-DD")}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
 

 
  const fetchData = async () => {
    try {
       setLoadingTable(true);
      const jobCodes = selectedSuggestions.map(suggestion => suggestion.job_num);
    const payload = {
  start_date: dayjs(selectedDateRange.startDate).format("YYYY-MM-DD"),
  end_date: dayjs(selectedDateRange.endDate).format("YYYY-MM-DD"),
  company_id: selectedCompanyId.toString(),
  etype: activeFilter,
};
 
if (user?.user_roles?.role !== 'Admin') {
    let phone = user?.phone;
 
    if (!phone) {
      try {
        const response = await api.get('/auth/me');
        phone = response?.phone;
      } catch (error) {
        console.error('Failed to fetch user phone from /auth/me', error);
      }
    }
 
    if (phone) {
      payload.supervisor_id = phone;
    }
  }
 
if (jobCodes.length > 0) {
  payload.job_codes = jobCodes;
}

const response = await api.post(`v1/reports/get-weekly`, payload);

 
      if (response.status === 200 && response.data.length > 0) {
        const defaultData = response.data[0];
        setTableData(defaultData);
        setBackupData(defaultData);
      
      } else {
      
        setTableData({});
        setBackupData({});
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingTable(false);
      setSearchQuery('');
    }
  };
 
useEffect(() => {

  if (
    selectedDateRange?.startDate &&
    activeFilter &&
    selectedCompanyId &&!openCalendar&&
    selectedSuggestions.length > 0 // Add this check
  ) {
   
    fetchData();
  }
}, [selectedDateRange, openCalendar,activeFilter, selectedCompanyId, selectedSuggestions,token]);
 
 
  useEffect(() => {
    if (!selectedSuggestions.length || !backupData?.emp_report) {
      // console.log("No suggestions or emp_report, resetting to backupData");
      setTableData(backupData);
      return;
    }
    const entries = Object.entries(backupData?.emp_report || {});
    const filteredEntries = entries.filter(([key, value]) => {
      const hasMatchingJob = value.activity?.some(activity =>
        activity.work_details?.some(work =>
        selectedSuggestions.some(s => s.job_num === '0000' || String(s.job_num) === String(work.job_id))

        )
      );
      return hasMatchingJob;
    });
    const filteredData = {
      ...backupData,
      emp_report: Object.fromEntries(filteredEntries),
    };
    setTableData(JSON.parse(JSON.stringify(filteredData))); // Deep copy to ensure state update
  }, [selectedSuggestions, backupData]);
 
const latestQueryRef = useRef("");
const debounceTimeout = useRef(null);
 
const fetchJobSuggestions = async (query) => {
  latestQueryRef.current = query;
  setLoadingSuggestions(true);
 
  try {
    // If query is empty or no company selected, clear suggestions and return
    if (!query.trim() || !selectedCompanyId) {
      setSuggestions([]);
      return;
    }
 
    const response = await api.get(`/v1/timesheets/get-jobs`, {
      params: {
        company_id: selectedCompanyId,
        job_num: query.trim(),
      },
    });
 
    let results = Array.isArray(response.data) ? response.data : [];
 
    // If query starts with "0", include "0000 - Overhead" if not already present
    if (query.trim().startsWith("0") && !results.some(job => job.job_num === "0000")) {
      results.unshift({ job_num: "0000", job_name: "Overhead" });
    }
 
    // Only update suggestions if this response matches the latest query
    if (latestQueryRef.current === query) {
      setSuggestions(results);
    }
  } catch (error) {
    console.error("Error fetching job suggestions:", error);
    setSuggestions([]);
  } finally {
    setLoadingSuggestions(false);
  }
}
const handleSearch = (e) => {
  const query = e.target.value;
  setSearchQuery(query);
 
  if (debounceTimeout.current) {
    clearTimeout(debounceTimeout.current);
  }
 
  // Clear suggestions immediately if query is empty
  if (!query.trim()) {
    setSuggestions([]);
    return;
  }
 
  debounceTimeout.current = setTimeout(() => {
    fetchJobSuggestions(query);
  }, 300);
};
 
const handleSuggestionClick = (item) => {
  if (selectedSuggestions.some((s) => s.job_num === item.job_num)) return;
 
  const newSelectedSuggestions = [...selectedSuggestions, item];
  setSelectedSuggestions(newSelectedSuggestions);
  setSelectedJobDetails([...selectedJobDetails, item]);
  setSearchQuery("");
  setSuggestions([]); // Clear suggestions after selection
  const entries = Object.entries(backupData?.emp_report || {});
  const filteredEntries = entries.filter(([key, value]) => {
    const hasMatchingJob = value.activity?.some((activity) =>
      activity.work_details?.some((work) =>
        newSelectedSuggestions.some((s) => String(s.job_num) === String(work.job_id))
      )
    );
    return hasMatchingJob;
  });
 
  const filteredData = {
    ...backupData,
    emp_report: Object.fromEntries(filteredEntries),
  };
  setTableData(JSON.parse(JSON.stringify(filteredData))); // Deep copy to ensure state update
};
 
  const handleClearTag = (job_num) => {
    const newSelectedSuggestions = selectedSuggestions.filter(item => item.job_num !== job_num);
    setSelectedSuggestions(newSelectedSuggestions);
    setSelectedJobDetails(selectedJobDetails.filter(item => item.job_num !== job_num));
 
    if (newSelectedSuggestions.length === 0) {
      console.log("No suggestions left, resetting to backupData");
      setTableData(backupData);
      return;
    }
    const entries = Object.entries(backupData?.emp_report || {});
    const filteredEntries = entries.filter(([key, value]) => {
      const hasMatchingJob = value.activity?.some(activity =>
        activity.work_details?.some(work =>
          newSelectedSuggestions.some(s => String(s.job_num) === String(work.job_id))
        )
      );
      return hasMatchingJob;
    });
 
 
    const filteredData = {
      ...backupData,
      emp_report: Object.fromEntries(filteredEntries),
    };
 
 
    setTableData(JSON.parse(JSON.stringify(filteredData))); // Deep copy to ensure state update
  };
 
  const fetchTabsData = async () => {
    try {
      const response = await api.get(`/v1/timesheets/company-details`);
      if (response.status === 200) {
        setCompanyTabs(response.data);
      if (user?.user_roles?.role === 'Project Manager') {
  const companyId = user?.user_info?.company_id;

  if (companyId && Array.isArray(response?.data)) {
    setSelectedCompanyId(companyId);

    const selectedCompany = response.data.find(
      (company) => company?.id?.toString() === companyId?.toString()
    );

    setSelectedCompanyName(selectedCompany?.name || '');
  } else {
    setSelectedCompanyId('');
    setSelectedCompanyName('');
  }

  setCurrentPage(1);
}

        // const defaultCompany = response.data[0];
        // setSelectedCompanyId(defaultCompany?.id);
        // setSelectedCompanyName(defaultCompany?.name);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingTable(false);
    }
  };
 
  useEffect(() => {
    fetchTabsData();
  }, []);
 
  const handleCompanyTabClick = (companyId) => {
    setSelectedCompanyId(companyId);
    const selectedCompany = companyTabs.find((company) => company.id.toString() === companyId.toString());
    setSelectedCompanyName(selectedCompany?.name || '');
    setCurrentPage(1);
  };
 
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setOpenCalendar(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
 const totalEntries = tableData?.emp_report ? Object.keys(tableData.emp_report).length : 0;

  const totalPages = Math.ceil(totalEntries / entriesPerPage);
 
  const paginatedData = () => {
    const startIndex = (currentPage - 1) * entriesPerPage;
    const endIndex = startIndex + entriesPerPage;
    const entries = Object.entries(tableData?.emp_report || {});
    const paginatedEntries = entries.slice(startIndex, endIndex);
    return {
      ...tableData,
      emp_report: Object.fromEntries(paginatedEntries),
    };
  };
 
  const handleEntriesChange = (e) => {
    const newEntriesPerPage = Number(e.target.value);
    setEntriesPerPage(newEntriesPerPage);
    setCurrentPage(1);
  };
 
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    const input = document.querySelector('input[placeholder="Search by Job Number"]');
    if (input) {
      input.addEventListener('keydown', handleKeyDown);
      return () => input.removeEventListener('keydown', handleKeyDown);
    }
  }, [hoveredSuggestionIndex, suggestions]);
 
  const isBothSelected = tempSelectedFilters.includes('EMP') && tempSelectedFilters.includes('EQP');
 
 
  const orderedWeekDays = getWeekDays(selectedDateRange.startDate);
 
  const handleformView=(viewdata)=>{
    setReportTableData(viewdata)
  }
 
const memoizedData = useMemo(() => paginatedData(), [paginatedData]);
const memoizedSuggestions = useMemo(() => selectedSuggestions, [selectedSuggestions]);
const memoizedWeekDays = useMemo(() => orderedWeekDays, [orderedWeekDays]);
 const memoizedFullData = useMemo(() => tableData, [tableData]);
  return (
  <SideNavLayout>
    <div className="flex bg-gray-100 max-h-[90vh] overflow-y-auto " style={{scrollbarWidth:'none'}}>
 
    <div className="sm:pt-7  w-full mb-12 min-h-screen ">
        <ReportsFilters
        setIsLoading={setIsLoading}
        ui={ui}
        setui={setui}
         filters={currentFilter}
         activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        startDate={dayjs(selectedDateRange.startDate).format("YYYY-MM-DD")}
        endDate={dayjs(selectedDateRange.endDate).format("YYYY-MM-DD")}
        selectedCompanyId={selectedCompanyId}
        data={tableData}
        selectedCompanyName={selectedCompanyName}
        selectedJobDetails={selectedJobDetails}
        selectedSuggestions={selectedSuggestions}
        // reportTableData={memoizedData}
 reportTableData={memoizedFullData}
         />
       
  {ui==0?
   <div>
        <div className=" flex gap-10 ">
        <div className="flex  ">
        <div className=" pb-1 flex flex-col ">
          <label className="text-left px-1 my-1">Company</label>
<select
  className={`px-2 py-2 border-[1.5px] text-[13px] font-inter border-[#DBDBDB] rounded-[5px] bg-white ${
    user?.user_roles?.role === 'Project Manager' ? 'cursor-not-allowed' : 'cursor-pointer'
  }`}
  value={selectedCompanyId}
  onChange={(e) => {
    if (user?.user_roles?.role !== 'Project Manager') {
      handleCompanyTabClick(e.target.value);
    }
  }}
  disabled={user?.user_roles?.role === 'Project Manager'}
>
  <option value="">
    Company
  </option>
  {companyTabs.map((company) => (
    <option
      key={company.id}
      value={company.id}
      disabled={user?.user_roles?.role === 'Project Manager' && company.id.toString() !== user?.user_info?.company_id.toString()}
    >
      {company.name === "INSTRUMENTATION & ELECTRICAL (I&E)" ? "I&E" : company.name}
    </option>
  ))}
</select>
        </div>
            {/* <div className="relative" ref={dropdownRef}>
          <div
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            className=" bg-[#F3F4F6] mt-1 rounded-md cursor-pointer"
          >
            <FilterAltIcon />
          </div>
 
          {isFilterOpen && (
            <div className="absolute z-10 mt-2 bg-white shadow-md border rounded-md p-4 w-44">
              {currentFilter.map((filter) => (
                <label key={filter.label} className="flex items-center gap-2 mb-2">
         <input
  type="checkbox"
  checked={tempSelectedFilters.includes(filter.value)}
  onChange={() => handleCheckboxChange(filter.value)}
  className="cursor-pointer"
/>
 
 
               <span className="uppercase  font-semibold text-[13px]">{filter.label === 'EMP' ? 'Employee' : filter.label === 'EQP' ? 'Equipment' : filter.label}</span>
 
                </label>
              ))}
             
 
              <button
                onClick={handleApplyFilters}
  className={`mt-2 w-[80px] px-3 py-2 rounded-md text-xs font-inter
    ${isBothSelected ? 'bg-gray-200 cursor-not-allowed' : 'bg-[#900] text-white'}`}              >
                Apply
              </button>
       
            </div>
          )}
            </div> */}
 
   
       
        </div>
       <div className="relative flex flex-col items-start">
  <label
    className={`text-left px-1 my-1 ${
      !selectedCompanyId ? "text-gray-400" : "text-black"
    }`}
  >
    Job Number
  </label>
  <div
    className={`flex items-center max-h-[34px] rounded-md border border-gray-300 bg-white px-4 flex-grow ${
      !selectedCompanyId ? "text-gray-400 opacity-40" : "text-black"
    }`}
  >
    <FontAwesomeIcon icon={faSearch} className="text-gray-500 mr-2 cursor-pointer" />
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => handleSearch(e)}
      disabled={!selectedCompanyId}
      placeholder="Search by Job Number"
      className={`w-full bg-transparent outline-none text-gray-700 ${
        !selectedCompanyId ? "cursor-not-allowed opacity-50" : ""
      }`}
    />
  </div>
{searchQuery && (
  <div>
    {loadingSuggestions ? (
      <div className="absolute left-0 top-16 bg-white border mt-1 z-50 w-full shadow-md rounded-md px-4 py-3 text-center">
        <span className="text-gray-500 text-sm"><CircularProgress size={20} /></span>
        {/* You can replace this with a spinner icon if using MUI or similar */}
      </div>
    ) : suggestions.length > 0 ? (
      <ul className="absolute left-0 top-16 bg-white border mt-1 z-50 max-h-60 overflow-y-auto custom-scrollbar w-[100%] shadow-md rounded-md">
        {suggestions.map((item,index) => (
          <li
            key={item.job_num}
className={`px-4 py-2 font-inter text-left text-sm cursor-pointer border-b ${
                            index === hoveredSuggestionIndex ? 'bg-gray-200' : 'hover:bg-gray-100'
                          }`}     
                                 onClick={() => handleSuggestionClick(item)}
                          onMouseEnter={() => setHoveredSuggestionIndex(index)}
                          onMouseLeave={() => setHoveredSuggestionIndex(-1)}
          >
            {item.job_num} - {item.job_name || "No Description"}
          </li>
        ))}
      </ul>
    ) : (
      <ul className="absolute left-0 top-16 bg-white border mt-1 z-50 max-h-60 overflow-y-auto w-[100%] shadow-md rounded-md">
        <li className="px-4 py-2 text-gray-500 cursor-default">
          No suggestions found
        </li>
      </ul>
    )}
  </div>
)}
 
          </div>
     
      <div className="flex flex-col relative">
          <label  className={`text-left px-1 my-1 ${
    selectedSuggestions.length === 0 ? 'text-gray-400' : 'text-black'
  }`}>Date Range</label>
       <div
  className={`flex relative bg-[white] items-center max-h-[40px] gap-4 mb-4 border border-gray-300 py-1 px-4 rounded ${
    selectedSuggestions.length === 0 ? 'cursor-not-allowed opacity-40' : 'cursor-pointer'
  }`}
  onClick={() => {
    if (selectedSuggestions.length > 0) {
      setOpenCalendar(true);
    }
  }}
>
  <img src={Calendar1} alt="" />
  <span className="text-[#293050] font-Font1 text-sm font-inter mt-1">
    {dayjs(selectedDateRange.startDate).format("MMM DD, YYYY")} - {dayjs(selectedDateRange.endDate).format("MMM DD, YYYY")}
  </span>
         </div>
 
 
      {/* Conditional rendering of DateRangeSelector */}
      {openCalendar && (
        <div ref={calendarRef}  className="absolute top-20 z-10">
          <DateRangeSelector
            selectedDateRange={selectedDateRange}
            setSelectedDateRange={setSelectedDateRange}
            onSubmit={handleDateRangeSubmit}
          />
        </div>
      )}
    </div>
        </div>
      <div className="flex flex-wrap pt-1 pb-4">
      {selectedSuggestions.length > 0 && (
                    <div className="flex flex-wrap items-center gap-2 w-full">
                      {selectedSuggestions.map((suggestion) => (
                        <div
                          key={suggestion.job_num}
                          className="border bg-[#8B18181A] rounded-full text-[#8B1818] font-inter px-4 text-sm flex items-center"
                        >
                          <span
                            className="mr-2 text-xl font-bold text-gray-600 cursor-pointer"
                            onClick={() => handleClearTag(suggestion.job_num)}
                          >
                            <CloseIcon style={{ width: '16px' }} />
                          </span>
                          <div className="flex flex-col my-0 gap-0 py-[2px]">
                            <span className="text-xs font-inter my-0 text-left">{suggestion.job_num}</span>
                            <span className="text-[#6B7280] my-0 font-inter text-xs">
                              {suggestion.job_name || "No Description"}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
      </div>
        {/* MUI Loader */}
        {loadingTable ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="200px">
            <CircularProgress size={50} />
          </Box>
        ) : (
          <div >
           
{totalEntries > 0 && selectedSuggestions.length > 0 && (
            <div className="flex items-center mb-2">
                <label htmlFor="entriesPerPage" className="mr-2 text-sm font-inter">Show</label>
                <select
                  id="entriesPerPage"
                  value={entriesPerPage}
                  onChange={handleEntriesChange}
                  className="px-2 py-1 border border-gray-300 rounded-md text-sm"
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span className="ml-2 text-sm font-inter">entries</span>
              </div>)}
{selectedCompanyId && selectedSuggestions.length > 0 && selectedDateRange.startDate && selectedDateRange.endDate && (
  <>
  {totalEntries > 0 && (
      <div className="flex justify-end mb-2">
        <button
          onClick={generateCSV}
          className="px-4 py-2 bg-[#900] text-white text-sm font-inter rounded-md hover:bg-[#700] transition-colors"
        >
          Generate CSV
        </button>
      </div>
    )}
          <ReportsData
           onFilteredData={handleformView}
            data={memoizedData}
           selectedSuggestions={memoizedSuggestions}
           orderedWeekDays={memoizedWeekDays}
           activeFilter={activeFilter}
           fetchData={fetchData}  
           startDate={dayjs(selectedDateRange.startDate).format("YYYY-MM-DD")}
             endDate={dayjs(selectedDateRange.endDate).format("YYYY-MM-DD")}
             isFilterOpen={isFilterOpen}
             setIsFilterOpen={setIsFilterOpen}
             isBothSelected={isBothSelected}
             dropdownRef={dropdownRef}
             tempSelectedFilters={tempSelectedFilters}
             handleCheckboxChange={handleCheckboxChange}
            currentFilter={currentFilter}
            handleApplyFilters={handleApplyFilters}
/>
    </>)}          
              {totalEntries > 0 && selectedSuggestions.length > 0 && (
                 <div className="flex justify-between items-center mt-4">
                  <div className="text-sm font-inter">
                    Showing {(currentPage - 1) * entriesPerPage + 1} to{' '}
                    {Math.min(currentPage * entriesPerPage, totalEntries)} of {totalEntries}{' '}
                    entries
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className={`px-3 py-1 rounded-md ${
                        currentPage === 1 ? 'bg-gray-200 cursor-not-allowed' : 'bg-[#900] text-white'
                      }`}
                    >
                      Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
                      <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        className={`px-3 py-1 rounded-md ${
                          currentPage === page ? 'bg-[#900] text-white' : 'bg-gray-200'
                        }`}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className={`px-3 py-1 rounded-md ${
                        currentPage === totalPages
                          ? 'bg-gray-200 cursor-not-allowed'
                          : 'bg-[#900] text-white'
                      }`}
                    >
                      Next
                    </button>
                  </div>
                </div>)}
   
 
          </div>
        )}
        </div>:<>
     <HistoryPage
      setIsLoading={ setIsLoading}
     historysearch={historysearch}
setHistorySearch={setHistorySearch}
historycalendar={historycalendar}
historycalendermodal={historycalendermodal}
setHistoryCalenderModal={setHistoryCalenderModal}
sethistoryCalendar={sethistoryCalendar}
historycalendarref={historycalendarref}
historyData={historyData}
     />
        
        </>}
      </div>
    </div>
       <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isloading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    
    </SideNavLayout>
 
 
  );
};
 
export default ReportHome;